/** App Store Connect product identifiers; kept aligned with web plan keys. */
export const APPLE_PRODUCT_IDS = Object.freeze({
  monthly: 'au.com.frontrowparents.individual.monthly',
  annual: 'au.com.frontrowparents.individual.annual',
  family_monthly: 'au.com.frontrowparents.family.monthly',
  family_annual: 'au.com.frontrowparents.family.annual',
});

export function appleProductIdForPlan(plan) {
  return Object.prototype.hasOwnProperty.call(APPLE_PRODUCT_IDS, plan)
    ? APPLE_PRODUCT_IDS[plan] : null;
}
